import actionTypes from '../constants/action-types';

const setUserFeatures = (userFeatures) => ({
  type: actionTypes.SET_USER_FEATURES,
  payload: { userFeatures },
});

export default setUserFeatures;
